import React, { FunctionComponent, useEffect, useRef, useState, CSSProperties } from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
    Link,
    useNavigate,
    useSearchParams,
    Navigate,
    useLocation,
    Location
} from "react-router-dom";

import { WithStringId, WorkOrder, Address } from './types';
import api from './api'
import { PageSelector } from './listings';
import { WorkOrderPrice } from './types';
import ImageBlur from './imageblur';
enum OrderDirection {
    Buyer,
    Seller
}

const getAddress = (address: Address | undefined, direction: OrderDirection, userDirection: OrderDirection, openShipping: () => void) => {
    const showAddress = (address: Address) => <div>
        <div>
            {address.addressLine1}
        </div>
        {address.addressLine2 && <div>
            {address.addressLine2}
        </div>}
        <div>
            {address.city}, {address.state} {address.postalCode}
        </div>
        <div>
            {address.country}
        </div>
        <button className='btn btn-link' onClick={openShipping}>(Change)</button>
    </div>;

    if (direction === userDirection) {
        if (address)
            return showAddress(address);
        return <button className='btn btn-link' onClick={openShipping}>Unspecified (required)</button>
    } else {
        if (address) {
            return <span>Added</span>
        } else {
            return <span>Pending</span>
        }
    }
}
const getPayment = (price: WorkOrderPrice, direction: OrderDirection, userDirection: OrderDirection) => {

}


const Modal: FunctionComponent<{ isOpen: boolean, toggleModal: () => void, title: string, footer?: React.ReactNode }> = ({ isOpen, toggleModal, title, children, footer }) => {
    const backdropStyle: CSSProperties = {
        zIndex: isOpen ? 1000 : -1, // Lower z-index value for the backdrop
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dark semi-transparent backdrop color
        display: isOpen ? 'block' : 'none',
    };

    return <div>
        <div style={backdropStyle} onClick={toggleModal} />
        <div className={`modal modal-lg ${isOpen ? 'show d-block' : ''}`}>
            <div className="modal-dialog  modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" onClick={toggleModal} />
                    </div>
                    <div className="modal-body">{children}</div>
                    <div className="modal-footer">
                        {footer || <button type="button" className="btn btn-secondary" onClick={toggleModal}>
                            Close
                        </button>}
                    </div>
                </div>
            </div>
        </div>
    </div>;
};


const OrderSide: FunctionComponent<{
    order: WithStringId<WorkOrder>,
    direction: OrderDirection,
    userDirection: OrderDirection
    openShipping: () => void
}> = ({ order, direction, userDirection, openShipping }) => {
    const items = direction === OrderDirection.Seller ? order.sellerItems : order.buyerItems;
    const address = direction === OrderDirection.Seller ? order.sellerShipping : order.buyerShipping;
    const itemsGathered = direction === OrderDirection.Seller ? order.sellerItemsCollected : order.buyerItemsCollected;
    const prices = direction === OrderDirection.Seller ? order.sellerPrice : order.buyerPrice;

    return <div>
        <h3>{direction === OrderDirection.Seller ? 'Seller' : 'Buyer'}</h3>
        <div className='mt-2'>
            <strong>Items</strong>
            <div className='row row-cols-1 row-cols-sm-2 row-cols-md-6 g-1'>
                {!items.length && <small>None.</small>}
                {items.map(item => <div className='col'>
                    <ImageBlur src={'/api/image/primary?listingId=' + item} />
                </div>)}
            </div>
        </div>
        <div className='mt-2'>
            <strong>Shipping/Pickup Address</strong>
            <div>{getAddress(address, direction, userDirection, () => openShipping())}</div>

        </div>
        <div>
            <strong>Items gathered</strong>
            <div>
                {!items.length ? <span>N/A</span> : <span>{itemsGathered ? 'Yes' : 'Pending'}</span>}
            </div>
        </div>
        <div>
            <strong>Payment</strong>
            <div>
                <div className='row'>
                    <div className='col-sm-6'>
                        <strong>Subtotal</strong>
                    </div>
                    <div className='col-sm-6'>
                        ${prices.subTotal}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm-6'>
                        <strong>Fee</strong>
                    </div>
                    <div className='col-sm-6'>
                        ${prices.labor}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm-6'>
                        <strong>Taxes (${prices.taxRate})</strong>
                    </div>
                    <div className='col-sm-6'>
                        ${prices.taxPrice}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm-6'>
                        <strong>Total to pay</strong>
                    </div>
                    <div className='col-sm-6'>
                        ${prices.total}
                    </div>
                </div>
                {!!prices.earnings && <div className='row'>
                    <div className='col-sm-6'>
                        <strong>Earnings</strong>
                    </div>
                    <div className='col-sm-6'>
                        <span className='text-success'>+${prices.earnings}</span>
                    </div>
                </div>}
            </div>
        </div>
    </div>
}
interface ShippingInterface {
    orderId: string,
    selectedAddress: Address | undefined,
    addresses: Array<Address>
}
const AddressEditor: FunctionComponent<{
    isOpen: boolean,
    close: () => void,
    onSelected: (address: Address) => void
    onUpdate: () => void,
    currentShipping?: ShippingInterface
}> = ({ isOpen, close, onUpdate, currentShipping, onSelected }) => {
    const [addingAddress, setAddingAddress] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine2, setAddressLine2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('Texas');
    const [postalCode, setPostalCode] = useState('');
    const [country, setCountry] = useState('United States');

    const handleSubmit = () => {
        console.log('running', currentShipping)
        if (!currentShipping) return;
        setSubmitting(true);

        const address: Address = {
            firstName,
            lastName,
            addressLine1,
            addressLine2,
            city,
            state,
            postalCode,
            country
        }
        const nextAddresses = [...currentShipping?.addresses, address]
        api.updateAddresses(nextAddresses)
            .then(() => {
                setAddingAddress(false);
                onUpdate();
            })

    }

    const addressFormCompleted = () => (firstName && lastName && addressLine1 && city && state && postalCode && country) ? true : false;

    const getFooter = () => {
        if (addingAddress) {
            return <>
                <button className='btn btn-secondary' onClick={() => setAddingAddress(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={!addressFormCompleted()} onClick={handleSubmit}>Submit</button>
            </>
        } else {
            return <><button className='btn btn-secondary' onClick={() => close()}>Close</button></>
        }
    }

    const ActualAddressEditor = () => {
        if (addingAddress || !currentShipping)
            return <form onSubmit={handleSubmit}>
                <div className="row mb-1">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="firstName" className="form-label">
                                First Name
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="firstName"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="lastName" className="form-label">
                                Last Name
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="lastName"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="row mb-1">
                    <div className="col-sm-8">
                        <div className="form-group">
                            <label htmlFor="addressLine1" className="form-label">
                                Address
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="addressLine1"
                                value={addressLine1}
                                onChange={(e) => setAddressLine1(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label htmlFor="addressLine2" className="form-label">
                                Address Line 2 (optional)
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="addressLine2"
                                value={addressLine2}
                                onChange={(e) => setAddressLine2(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="row mb-1">
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label htmlFor="city" className="form-label">
                                City
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="city"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-sm-5">
                        <div className="form-group">
                            <label htmlFor="state" className="form-label">
                                State
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="state"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="form-group">
                            <label htmlFor="postalCode" className="form-label">
                                Postal Code
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="postalCode"
                                value={postalCode}
                                onChange={(e) => setPostalCode(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="row mb-1">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label htmlFor="country" className="form-label">
                                Country
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="country"
                                value={country}
                                onChange={(e) => setCountry(e.target.value)}
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </form>
        else {
            return <ul className="list-group">
                {currentShipping.addresses.map(address => <li className='list-group-item cursor-pointer' onClick={() => onSelected(address)}>
                    <div>{address.firstName} {address.lastName}</div>
                    <div>{address.addressLine1}, {address.addressLine2 && address.addressLine2 + ', '}
                        {address.city}, {address.state}, {address.postalCode}</div>
                    <div>{address.country}</div>
                </li>
                )}
                <li className="list-group-item" onClick={() => setAddingAddress(true)}>
                    Add new address
                </li>
            </ul>
        }
    }

    return <Modal isOpen={isOpen} title='Shipping/Pickup Address' toggleModal={() => close()} footer={getFooter()}>
        {isOpen && currentShipping && ActualAddressEditor()}
    </Modal>

}
export const Orders: FunctionComponent<{ userId: string }> = ({ userId }) => {
    const [pages, setPages] = useState(1);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [orders, setOrders] = useState([] as Array<WithStringId<WorkOrder>>)
    const [shippingOpen, setShippingOpen] = useState(undefined as undefined | ShippingInterface); //orderId

    const refreshOrders = () => {
        api.getOrders(pageSize, page).then(({ pages, orders }) => {
            setPages(pages);
            setOrders(orders);
            console.log('Orders:', orders);
        })
    }
    useEffect(() => {
        refreshOrders();
    }, [])
    const openShipping = (orderId: string): void => {
        api.getAddresses()
            .then(addresses => {
                const order = orders.at(orders.findIndex(order => order._id === orderId)) as WithStringId<WorkOrder<string>>;
                setShippingOpen({
                    orderId,
                    addresses,
                    selectedAddress: order.sellerId === userId ? order.sellerShipping : order.buyerShipping
                })
            })
    }
    const userDirection = (order: WithStringId<WorkOrder>) => userId === order.sellerId ? OrderDirection.Seller : OrderDirection.Buyer;

    const [pageSelector, pageSizeSelector] = PageSelector({ pages, page, pageSize, alwaysShow: false, onPage: (page, size) => { setPage(page); setPageSize(size) }});

    return <div>
        {pageSizeSelector}
        {<AddressEditor
            isOpen={!!shippingOpen}
            onUpdate={() => shippingOpen && openShipping(shippingOpen.orderId)}
            onSelected={address => {
                if (!shippingOpen) return;
                api.setAddress(shippingOpen.orderId, address).then(() => {
                    refreshOrders();
                    setShippingOpen(undefined);
                })
            }}
            close={() => setShippingOpen(undefined)}
            currentShipping={shippingOpen} />}
        <div className='row'>
            <div className='offset-md-3 col-md-6'>
                {!!orders.length && <div className="list-group mb-5">
                    {orders.map(order => {
                        return <div className='list-group-item'>
                            <div className='border-bottom d-flex justify-content-between p-2'>
                                <div>
                                    <strong>Order ID: </strong>
                                    <span>{order._id}</span>
                                </div>
                                <div>
                                    <strong>Last updated: </strong>
                                    <span>{new Date(order.dateUpdated).toLocaleString()}</span>
                                </div>
                            </div>
                            <div className='row mt-3'>

                                <div className='col-sm-6'>
                                    <OrderSide order={order} direction={OrderDirection.Seller} userDirection={userDirection(order)} openShipping={() => openShipping(order._id)} />
                                </div>
                                <div className='col-sm-6'>
                                    <OrderSide order={order} direction={OrderDirection.Buyer} userDirection={userDirection(order)} openShipping={() => openShipping(order._id)} />
                                </div>
                            </div>

                        </div>
                    })}

                </div>
                }
                {!orders.length && <div className='text-center'>
                    <strong>No orders</strong>
                </div>}
            </div>
        </div>
        {pageSelector}
    </div>
}
